// FLIP (First-Last-Invert-Play) for transcript paper-slip rearrangement.
// Measure before saving the new block order; animate the existing keyed DOM
// into its final position after React commits. Never animate source data.
export function capturePassageRects(container){
  const positions=new Map();
  for(const element of container?.querySelectorAll('[data-passage-id]')||[]){
    const rect=element.getBoundingClientRect();
    positions.set(element.dataset.passageId,{top:rect.top,left:rect.left});
  }
  return positions;
}

export function animatePassageReorder(container,previous,{duration=340,reducedMotion=false}={}){
  if(!container || !previous?.size || reducedMotion)return [];
  const animations=[];
  for(const element of container.querySelectorAll('[data-passage-id]')){
    const prior=previous.get(element.dataset.passageId);
    if(!prior || typeof element.animate!=='function')continue;
    const next=element.getBoundingClientRect();
    const x=prior.left-next.left,y=prior.top-next.top;
    if(Math.abs(x)<1 && Math.abs(y)<1)continue;
    try{
      animations.push(element.animate(
        [{transform:`translate3d(${x}px,${y}px,0)`},{transform:'translate3d(0,0,0)'}],
        {duration,easing:'cubic-bezier(.2,.76,.2,1)',fill:'none'}
      ));
    }catch{/* Web Animations unsupported: move instantly, editing still works. */}
  }
  return animations;
}
